module.exports = __webpack_public_path__ + "img/dwshengchan.ae33dc4c.png";